import IrosTeachersPage from './IrosTeachersPage';
export default IrosTeachersPage;
